/* tslint:disable */
/* eslint-disable */
/**
 * Berichtsmanagement
 * Berichte verwalten
 *
 * The version of the OpenAPI document: 1.0.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RechnungsdatenAorv
 */
export interface RechnungsdatenAorv {
    /**
     * 
     * @type {string}
     * @memberof RechnungsdatenAorv
     */
    rechnungsnummer?: string;
    /**
     * 
     * @type {string}
     * @memberof RechnungsdatenAorv
     */
    externeBestellNummer?: string;
    /**
     * 
     * @type {string}
     * @memberof RechnungsdatenAorv
     */
    bauvorhaben?: string;
}

/**
 * Check if a given object implements the RechnungsdatenAorv interface.
 */
export function instanceOfRechnungsdatenAorv(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RechnungsdatenAorvFromJSON(json: any): RechnungsdatenAorv {
    return RechnungsdatenAorvFromJSONTyped(json, false);
}

export function RechnungsdatenAorvFromJSONTyped(json: any, ignoreDiscriminator: boolean): RechnungsdatenAorv {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'rechnungsnummer': !exists(json, 'Rechnungsnummer') ? undefined : json['Rechnungsnummer'],
        'externeBestellNummer': !exists(json, 'ExterneBestellNummer') ? undefined : json['ExterneBestellNummer'],
        'bauvorhaben': !exists(json, 'Bauvorhaben') ? undefined : json['Bauvorhaben'],
    };
}

export function RechnungsdatenAorvToJSON(value?: RechnungsdatenAorv | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Rechnungsnummer': value.rechnungsnummer,
        'ExterneBestellNummer': value.externeBestellNummer,
        'Bauvorhaben': value.bauvorhaben,
    };
}

